import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-r from-secondary to-tertiary text-white overflow-hidden mt-16">
      {/* Moving shapes/background animation */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute bg-white opacity-10 rounded-full w-20 h-20 animate-ping top-10 left-10"></div>
        <div className="absolute bg-white opacity-10 rounded-full w-32 h-32 animate-bounce top-1/2 left-3/4"></div>
        <div className="absolute bg-white opacity-10 rounded-full w-16 h-16 animate-spin-slow top-3/4 left-1/4"></div>
      </div>

      <div className="relative z-10 px-10 md:px-20 py-16 grid md:grid-cols-3 gap-12 items-start">
        {/* About Section */}
        <div className="space-y-4">
          <h2 className="text-2xl font-bold mb-2">Afya Ustawi Foundation</h2>
          <p className="text-gray-200 text-sm leading-relaxed">
            Empowering communities through health, education, environmental stewardship, and youth engagement.
          </p>
          <div className="flex space-x-4 mt-2">
            <a className="hover:text-yellow-400 transition-transform transform hover:scale-125">
              <FaFacebookF />
            </a>
            <a className="hover:text-yellow-400 transition-transform transform hover:scale-125">
              <FaTwitter />
            </a>
            <a className="hover:text-yellow-400 transition-transform transform hover:scale-125">
              <FaInstagram />
            </a>
            <a className="hover:text-yellow-400 transition-transform transform hover:scale-125">
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="space-y-4">
          <h3 className="text-xl font-semibold mb-2">Quick Links</h3>
          <ul className="text-sm font-light space-y-2">
            <li className="hover:text-yellow-400 transition-colors cursor-pointer">Home</li>
            <li className="hover:text-yellow-400 transition-colors cursor-pointer">About Us</li>
            <li className="hover:text-yellow-400 transition-colors cursor-pointer">Programs</li>
            <li className="hover:text-yellow-400 transition-colors cursor-pointer">Donate</li>
            <li className="hover:text-yellow-400 transition-colors cursor-pointer">Contact</li>
          </ul>
        </div>

        {/* Contact Form */}
        <div className="space-y-4">
          <h3 className="text-xl font-semibold mb-2">Contact Us</h3>
          <form className="flex flex-col space-y-3 w-full">
            <input
              type="text"
              placeholder="Your Name"
              className="px-4 py-2 rounded-lg text-gray-800 w-full focus:outline-none focus:ring-2 focus:ring-yellow-400 transition"
            />
            <input
              type="email"
              placeholder="Your Email"
              className="px-4 py-2 rounded-lg text-gray-800 w-full focus:outline-none focus:ring-2 focus:ring-yellow-400 transition"
            />
            <textarea
              placeholder="Your Message"
              rows="4"
              className="px-4 py-2 rounded-lg text-gray-800 w-full focus:outline-none focus:ring-2 focus:ring-yellow-400 transition resize-none"
            ></textarea>
            <button
              type="submit"
              className="px-6 py-2 bg-yellow-400 rounded-lg font-semibold hover:bg-yellow-500 transition-all transform hover:scale-105"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>

      <div className="border-t border-white/20 py-4 text-center text-gray-200 text-sm">
        &copy; {new Date().getFullYear()} Afya Ustawi Foundation. All rights reserved.
      </div>
    </footer>
  );
}
